<template>
    <transition name="modal">
        <div id="div-modal-tmpl" class="modal-mask" @click="closeModal">
            <div class="modal-content" :style="'top:'+position.top+'px;'+((position.left !== undefined ? 'left:'+position.left+'px':'right:'+position.right+'px'))" v-hotkey="keymap">
                <v-card v-for="player in goalkeepers" :key="player.id" class="player-btn theme-background theme-border" outlined flat depressed tile large @click.prevent="changeGoalKeeper(teamId, player.id)" :class="player.id === actualGoalKeeper.id ? 'actual-goalkeeper' : ''">
                    <v-card flat tile class="player-number text-no-wrap rounded-circle transparent" v-if="player.jersey">{{ player.jersey }}</v-card>
                    <v-card flat tile class="player-name flex-grow-1 text-truncate transparent">{{ player.name }}</v-card>
                    <v-card flat tile class="player-cards d-inline-flex text-no-wrap align-center transparent" v-if="player.id !== actualGoalKeeper.id"> <v-icon class="theme-hightext">mdi-swap-vertical</v-icon></v-card>
                </v-card>
                <v-card class="player-btn theme-background theme-border" outlined flat depressed tile large @click.prevent="changeGoalKeeper(teamId, 0)" :class="!numberOfActualGoalkeeper ? 'actual-goalkeeper' : ''">
                    <v-card flat tile class="empty-gate transparent">
                        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" :style="{fill: $vuetify.theme.dark ? '#ffffff' : '#000000'}"><path d="m4 16v2h-2v-2zm18 0v2h-2v-2zm-18-3v2h-2v-2zm18 0v2h-2v-2zm-18-3v2h-2v-2zm18 0v2h-2v-2zm-18-3v2h-2v-2zm9 0v2h-2v-2zm-6 0v2h-2v-2zm9 0v2h-2v-2zm3 0v2h-2v-2zm-9 0v2h-2v-2zm12 0v2h-2v-2z" fill-rule="evenodd"/></svg>
                    </v-card>
                    <v-card flat tile class="player-name flex-grow-1 text-truncate d-inline-flex transparent"> Üres kapu </v-card>
                    <v-card flat tile class="player-cards d-inline-flex text-no-wrap align-center transparent" v-if="actualGoalKeeper.id !== 0"> <v-icon class="theme-hightext">mdi-swap-vertical</v-icon></v-card>
                </v-card>
            </div>
        </div>
    </transition>
</template>

<script>
    import eventBus from '@/eventBus';
    import { hotkeys } from '@/plugins/hotkeys';
    import CONSTANTS from '@/constants';

    import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
        name: "GoalKeeperModal",
        props: {
            goalkeepers: Array,
            position: Object,
            teamId: String,
            playerId: Number,
            actualGoalKeeper: Object,
            isActive: Boolean,
            hotkeys: Boolean,
        },
        data: () => ({
            lastGoalkeeperId: 0,
        }),
        mounted() {
            let self = this;

            self.lastGoalkeeperId = self.actualGoalkeeperId();

            this.$busOn(CONSTANTS.EVENTS.CHANGE.GOALKEEPERS, function(goalkeepers) {
                self.lastGoalkeeperId = goalkeepers[self.teamId];
            });
        },
        computed: {
            numberOfActualGoalkeeper: function() {
                let actualGoalKeeperId = this.actualGoalkeeperId();

                return this.goalkeepers.find(goalkeeper => goalkeeper.id === actualGoalKeeperId);
            },
            keymap: function() {
                let self = this;
                return {
                    [hotkeys['emptyGoal']]: self.hotkeys ? self.emptyGoalkeeper : '',
                    [hotkeys['fillGoal']]: self.hotkeys ? self.fillGoalkeeper : '',
                }
            },
        },
        methods: {
            actualGoalkeeperId() {
                if(this.actualGoalKeeper && Object.keys(this.actualGoalKeeper).length) {
                    return this.actualGoalKeeper.id;
                }

                return 0;
            },
            emptyGoalkeeper() {
                if(this.isActive) {
                    this.changeGoalKeeper(this.teamId, 0);
                }
            },
            fillGoalkeeper() {
                if(this.isActive) {
                    this.changeGoalKeeper(this.teamId, this.lastGoalkeeperId);
                }
            },
            closeModal() {
                eventBus.$emit(CONSTANTS.ACTIONS.CLOSE.MODAL);
            },
          changeGoalKeeper(teamId, playerId) {
            if(playerId) {
              this.lastGoalkeeperId = playerId;
            }

            // --- MÓDOSÍTÁS KEZDETE ---
            // Először küldjük el a bezárási parancsot, hogy az overlay azonnal eltűnjön
            this.closeModal();
            // --- MÓDOSÍTÁS VÉGE ---

            // Ezután küldjük el az adatváltozást
            // JAVÍTÁS: A teamId-t ellenőrizzük, mert néha 'A' vagy 'B' jön 'teamA' helyett
            let targetKey = (teamId === 'teamA' || teamId === 'A') ? 'team_a_actual_goalkeeper' : 'team_b_actual_goalkeeper';

            eventBus.$emit(CONSTANTS.EVENTS.CHANGE.GAMEDATA, targetKey, { id: playerId });
          }
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        direction: ltr;
    }

    .cls-modal-close-btn {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(0.95);
        transform: scale(0.95);
    }
    .modal-content {
        min-width: 200px;
        height: auto;
        background-color: transparent;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        border: 3px solid #000000;
        position: absolute;
        z-index: 2;
    }
    .player-btn {
        padding: 10px 5px 10px 7px;
        border-bottom-width: 1px;
        border-bottom-style: solid;
    }
    .player-name {
        line-height: 20px;
    }
    .player-card-goal {
        margin-right: 10px !important;
        padding: 8px 7px 6px 7px;
        min-width: 35px !important;
    }
    .player-number {
        padding: 10px 9px 9px 7px;
        margin-right: 10px;
        min-width: 35px !important;
        max-height: 35px !important;
        max-width: 35px !important;
    }
    .theme--light.actual-goalkeeper {
        background: #94c4ff !important;
    }
    .theme--dark.actual-goalkeeper {
        background: #40434f !important;
    }
    .empty-gate {
        padding: 0 !important;
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        height: 35px;
        width: 35px;
        margin-right: 10px;
    }
</style>
